const CustomSVG = ({ children, onClick, className }) => {
  return (
    <div onClick={onClick} className={className} data-testid='custom-svg-container'>
      {children}
    </div>
  );
};
export default CustomSVG;
